// extracted by mini-css-extract-plugin
export default {"navbar__menu":"NavLinks_navbar__menu__pPcie","navbar__item":"NavLinks_navbar__item__0JD+S","navbar__link":"NavLinks_navbar__link__LuvV8","open":"NavLinks_open__dUwp5"};